export const logs = [
  {
    title: "Project: Vanda Wallet",
    date: "2025-08-26",
    version: "1.0.76",
    changes: [
      "بازطراحی صفحات داشبورد و رفع باگ‌های مرتبط.",
      "بازطراحی صفحات انتقال وجه و رفع باگ‌های مرتبط.",
      "افزودن امکان انتقال وجه داخلی.",
      "اضافه شدن امکان لغو درخواست برداشت و بروزرسانی موجودی پس از ایجاد درخواست.",
      "رفع مشکل مربوط به شماره شبا‌های ذخیره‌شده در فرم برداشت.",
      "اضافه شدن دکمه انتقال برداشت به کارت شماره شبا‌های ذخیره‌شده و امکان کپی سریع شماره شبا.",
      "اصلاح مشکلات ریسپانسیو در صفحه ورود و بخش‌های مختلف پروفایل.",
      "بازسازی صفحه پروفایل و بهبود تجربه کاربری.",
      "اضافه شدن لاگ‌های سیستمی و فایل manifest.json برای PWA.",
      "رفع مشکل نمایش آیکن تومان در صفحه انتقال وجه."
    ]
  },
  {
    title: "Project: Vanda Wallet",
    date: "2025-01-29",
    version: "1.0.75",
    changes: [
      "در صفحه پرداخت‌ها، هنگام کلیک روی دکمه دانلود خروجی پرداخت در کارت پرداخت، علاوه بر دانلود فایل، صفحه جزئیات پرداخت نیز باز می‌شد. این مشکل برطرف شد و از اجرای هم‌زمان هر دو عملیات جلوگیری شد.",
      "در صفحه جزئیات پرداخت، دکمه دانلود جزئیات عملکرد صحیحی نداشت و به URL نادرستی ارجاع داده می‌شد. این مشکل اصلاح شد و لینک دانلود به مسیر صحیح هدایت گردید."
    ]
  },
];
